import Breadcrumbs from "../../../components/shared/Breadcrumbs/Breadcrumbs";
import { PageContainer } from "../../../styled";
import UserList from "../../../components/shared/UserList/UserList";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import type { IUser } from "../../../components/shared/UserList/UserList.types";
import { Button } from "../../../components/shared/Button/Button";
import { ButtonWrapper } from "../../Settings/AccountDetails/AccountDetails.styled";

const FleetCrewSetUp = () => {
  const navigate = useNavigate();

  const handleEditUser = useCallback(
    (user: IUser) => {
      // get yacht id here
      navigate(`/settings/userlist/edit-user/${user.userid}`);
    },
    [navigate],
  );
  return (
    <PageContainer>
      <Breadcrumbs border={false}>
        <ButtonWrapper>
          <Button
            onClick={() => navigate("/management/crew-set-up/crew-transfer")}>
            Crew Transfer Menu
          </Button>
        </ButtonWrapper>
      </Breadcrumbs>
      {/* <UserList onUserSelect={handleEditUser} /> */}
    </PageContainer>
  );
};
export default FleetCrewSetUp;
